import { themr } from '@friendsofreactjs/react-css-themr';
import SnackbarMessage from './SnackbarMessage';

export default themr('SnackbarMessage')(SnackbarMessage);
